import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  mainContainer: {
    alignSelf: 'center',
    flexGrow: 1,
  },
  heading: {
    justifyContent: 'flex-start',
    gap: 5,
  },
  headerText: {
    textAlign: 'left',
    marginBottom: 10,
  },
  buttonStyle: {
    paddingHorizontal: 15,
    borderRadius: 50,
    marginVertical: 3,
  },
});
